import styled from 'styled-components'

import { button } from 'components/Editor/styled/Button'

const ButtonStyled = styled.button`
  ${button}
  border-radius: 6px;
  cursor: pointer;
`

export default ButtonStyled
